// 开发环境客户端警告过滤器
export default defineNuxtPlugin(() => {
  if (process.env.NODE_ENV !== 'development') {
    return
  }

  // 检查是否启用静音模式
  const isQuietMode = process.env.DEV_QUIET === 'true' || process.env.SUPPRESS_WARNINGS === 'true'
  
  if (!isQuietMode) {
    return
  }

  // 需要过滤的警告模式
  const WARNING_FILTERS = [
    'inject() can only be used inside setup()',
    'injection "loginModal" not found',
    'injection "CompleteInfo" not found',
    '[Vue warn]:',
    'Non-reactive',
    'runtime-core.esm-bundler.js',
    // 添加更多需要过滤的警告模式
  ]

  // 保存原始的 console 方法
  const originalConsole = {
    warn: console.warn,
    error: console.error
  }

  // 过滤函数
  const shouldFilter = (message: string): boolean => {
    return WARNING_FILTERS.some(filter => 
      message.includes(filter)
    )
  }

  // 重写 console.warn
  console.warn = (...args: any[]) => {
    const message = args.join(' ')
    if (!shouldFilter(message)) {
      originalConsole.warn(...args)
    }
  }

  // 重写 console.error (可选)
  console.error = (...args: any[]) => {
    const message = args.join(' ')
    // 只过滤已知的非关键错误，保留重要错误信息
    if (!shouldFilter(message)) {
      originalConsole.error(...args)
    }
  }

  // Vue 应用错误处理
  if (typeof window !== 'undefined') {
    const app = useNuxtApp()
    
    // 捕获 Vue 警告
    app.hook('vue:error', (error, instance, info) => {
      const errorMessage = error.toString()
      if (!shouldFilter(errorMessage)) {
        originalConsole.error('Vue Error:', error, info)
      }
    })
  }

  console.log('🔇 客户端警告过滤器已启用')
})